export default "__VITE_ASSET__Chi5CSUQ__"